// utils/axios.js
import axios from 'axios';
import {buildFullPath} from "./url";
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  withCredentials: true,
});

export const api_stream= async (url:string,options:RequestInit={})=>{
  url = buildFullPath(process.env.REACT_APP_BASE_API_URL, url);
  const defaultOptions: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      // Add other headers here if needed
    },
    credentials: 'include',
    ...options, // Merge any additional options passed in
  };

  return await fetch(url,defaultOptions);
}


// Request interceptor
api.interceptors.request.use(request => {
  // Always return the request otherwise it will be stuck here
  return request;
}, error => {
  // Log any request error
  console.error('Request error:', error);

  return Promise.reject(error);
});

export default api;
